import { Modal, ModalHeader, ModalBody, Col, Row } from "reactstrap";

const DetailVersementModal = ({ isOpen, toggle, transaction }) => {
  if (!transaction) {
    return null; // ou un loader
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}className="modal-centered-content">
      <ModalHeader className="modal-title-center" toggle={toggle}>Détail du versement</ModalHeader>
      <ModalBody className="modal-centered-content">

        <Row className="mb-2 align-items-center">
        <Col md={6} className="tel">Marchand</Col> 
        <Col md={6} className="tels">{transaction?.merchantAccountName}</Col>
      </Row>
       <Row className="mb-2 align-items-center">
        <Col md={6} className="tel">Business</Col>
        <Col md={6} class="tels">{transaction?.developerAccountName}</Col>
      </Row>
        <Row className="mb-2 align-items-center">
        <Col  md={6}className="tel" >Date</Col>
        <Col  md={6}className="tels">{new Date(transaction?.createdAt).toLocaleString()}</Col>
       </Row>
        <Row className="mb-2 align-items-center">
          <Col md={6} className="tel">Montant</Col>
          <Col md={6} className="tels">{transaction?.amount} {transaction?.currency}</Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col className="tel">Compte</Col>
          <Col md={6} className="tels">{transaction?.paymentMethodName}</Col>
        </Row>
        <Row className="mb-2 align-items-center">
          <Col md={6} className="tel">Numéro de téléphone</Col>
          <Col md={6} className="tels">{transaction?.clientNumber}</Col>
        </Row>
         <Row className="mb-2 align-items-center">
          <Col md={6} className="tel">Statut</Col>
          <Col md={6} className="tels">
          {transaction?.status === "PENDING" ? "En cours" : transaction?.status === "SUCCESS" ? "Succès" : transaction?.status}</Col>
        </Row>
         <Row className="mb-2 align-items-center">
          <Col md={6} className="tel">Reference du transaction</Col>
          <Col md={6} className="tels">{transaction?.transactionReference}</Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default DetailVersementModal;
